import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ForumAttachedFile from './ForumAttachedFile';

export default class ForumAttachList extends Component {
  static propTypes = {
    vimeoVideoId: PropTypes.string,
    vimeoLink: PropTypes.string,
    attachments: PropTypes.array.isRequired,
  };

  render() {
    const { vimeoLink, vimeoVideoId, attachments } = this.props;
    return (
      <div className="post-content__file-container">
        {vimeoLink ? <ForumAttachedFile type="vimeoVideo" vimeoLink={vimeoLink} vimeoVideoId={vimeoVideoId} /> : '' }
        {attachments.map((item, idx) => <ForumAttachedFile key={idx} attach={item} />)}
      </div>
    );
  }
}
